var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',[_c('b-link',{attrs:{"href":"#","title":"Open this job","to":{
				name: 'jobupdate',
				params: { id: _vm.job.Id },
			}}},[_vm._v(_vm._s(_vm.job.Id))])],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.job.Clock.Name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.jobTypeName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.job.Status.Name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.job.QuotesTotal != null ?  _vm.job.QuotesTotal : 0))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.formatDate(_vm.job.Due)))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d9bfd4d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/job/job-list-row.vue
// module id = null
// module chunks = 